import { defineField, defineType } from 'sanity'
import { richTextSimple } from '../../data/richText'
import extractTextFromRichText from '../../utils/extractFromRichText'

export default defineType({
  name: 'textWithImage',
  title: 'Text with Image',
  type: 'object',
  fields: [
    defineField({
      name: 'content',
      title: 'Content',
      type: 'array',
      of: richTextSimple,
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'image',
      title: 'Image',
      type: 'image',
      options: {
        hotspot: true,
      },
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'imagePosition',
      title: 'Image Position',
      type: 'string',
      options: {
        layout: 'radio',
        list: [
          { title: 'Left', value: 'left' },
          { title: 'Right', value: 'right' },
        ],
      },
      initialValue: 'left',
    }),
  ],
  preview: {
    select: {
      content: 'content',
      media: 'image',
    },
    prepare({ content, media }) {
      const title = extractTextFromRichText(content) || 'Text with Image'

      return {
        title,
        subtitle: 'Text with Image',
        media,
      }
    },
  },
})
